import { login, LoginBody } from '@/api/admin/dashboard';
import { JWT_KEY } from '@/constants/app';
import { programAtom } from '@/stores/program';
import { clientCookies } from '@/utils/cookies';
import { atom } from 'jotai';

export const _accessTokenAtom = atom<string | null>(
  clientCookies.get(JWT_KEY) ?? null
);
export const accessTokenAtom = atom(
  (get) => get(_accessTokenAtom),
  (get, set, next: string | null) => {
    if (next) {
      clientCookies.set(JWT_KEY, next, {
        expires: 1,
        path: '/',
        sameSite: 'lax',
        secure: import.meta.env.DEV,
      });
    } else {
      clientCookies.destroy(JWT_KEY, {
        path: '/',
        secure: import.meta.env.DEV,
        sameSite: 'lax',
      });
    }

    set(_accessTokenAtom, next);
  }
);

export const isAdminAtom = atom((get) => !!get(accessTokenAtom));

export const loginAtom = atom(null, async (get, set, body: LoginBody) => {
  const jwt = await login(body);
  set(accessTokenAtom, jwt);
});

export const logoutAtom = atom(null, (get, set) => {
  set(programAtom, null);
  set(accessTokenAtom, null);
});
